import { render, staticRenderFns } from "./Orderjx.vue?vue&type=template&id=562b91c6&scoped=true"
import script from "./Orderjx.vue?vue&type=script&lang=js"
export * from "./Orderjx.vue?vue&type=script&lang=js"
import style0 from "./Orderjx.vue?vue&type=style&index=0&id=562b91c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562b91c6",
  null
  
)

export default component.exports